(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reel-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('.reels-section');
  var wrapper = document.querySelector('.reels-wrapper');
  if (!section || !wrapper) return;

  var prevBtn  = section.querySelector('.reels-btn.prev');
  var nextBtn  = section.querySelector('.reels-btn.next');
  var cards    = Array.prototype.slice.call(wrapper.querySelectorAll('.reel-card'));
  var modal    = document.getElementById('reelModal');
  var stage    = document.getElementById('reelStage');
  var closeBtn = document.getElementById('reelClose');

  var nearViewport = false;
  var inViewport   = false;
  var modalOpen    = false;
  var activeVideo  = null;
  var activePh     = null;

  /* ───────── source loading ───────── */
  function ensureSrc(video) {
    if (!video || video.dataset.loaded === '1') return;
    var src = video.dataset.src;
    if (!src) return;
    video.dataset.loaded = '1';
    video.preload = 'auto';
    video.setAttribute('src', src);
    video.load();
  }

  function warmQueued() {
    if (!nearViewport) return;
    cards.forEach(function (card) {
      if (card.dataset.warm === '1') ensureSrc(card.querySelector('video'));
    });
  }

  /* ───────── playback ───────── */
  var MAX_CONCURRENT = 4;   /* sources are 1080p — don't decode more than a few at once */

  function visibleCards() {
    var mid = wrapper.scrollLeft + wrapper.clientWidth / 2;
    return cards
      .filter(function (c) { return c.dataset.hvis === '1'; })
      .sort(function (a, b) {
        return Math.abs(a.offsetLeft + a.offsetWidth / 2 - mid) -
               Math.abs(b.offsetLeft + b.offsetWidth / 2 - mid);
      })
      .slice(0, MAX_CONCURRENT);
  }

  function syncPlayback() {
    var allowed = inViewport && !modalOpen && !document.hidden ? visibleCards() : [];
    cards.forEach(function (card) {
      var v = card.querySelector('video');
      if (!v || v === activeVideo) return;
      if (allowed.indexOf(card) !== -1) {
        ensureSrc(v);
        v.muted = true;
        if (v.paused) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      } else if (!v.paused) {
        v.pause();
      }
    });
  }

  if ('IntersectionObserver' in window) {
    /* queue cards that are near the strip's horizontal viewport */
    var warmObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.dataset.warm = '1';
          if (nearViewport) ensureSrc(e.target.querySelector('video'));
        }
      });
    }, { root: wrapper, rootMargin: '0px 320px', threshold: 0 });

    /* which cards are actually on screen horizontally */
    var hObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.dataset.hvis = e.isIntersecting ? '1' : '0'; });
      syncPlayback();
    }, { root: wrapper, threshold: 0.4 });

    cards.forEach(function (c) { warmObs.observe(c); hObs.observe(c); });

    /* start buffering well before the section is reached */
    new IntersectionObserver(function (entries) {
      nearViewport = entries[0].isIntersecting;
      if (nearViewport) warmQueued();
    }, { rootMargin: '900px 0px', threshold: 0 }).observe(section);

    /* play only while the section is actually on screen */
    new IntersectionObserver(function (entries) {
      inViewport = entries[0].isIntersecting;
      syncPlayback();
    }, { threshold: 0.05 }).observe(section);
  } else {
    nearViewport = true;
    inViewport = true;
    cards.forEach(function (c) { c.dataset.hvis = '1'; c.dataset.warm = '1'; });
    warmQueued();
    syncPlayback();
  }

  document.addEventListener('visibilitychange', syncPlayback);

  /* ───────── lightbox ─────────
     the card's own <video> is moved into the modal, so whatever is already
     buffered keeps playing — no second download, no restart. */
  function openModal(card) {
    var v = card.querySelector('video');
    if (!v || !modal || !stage) return;

    ensureSrc(v);

    var ph = document.createElement('div');
    ph.className = 'reel-video reel-video--ph';
    var poster = v.getAttribute('poster');
    if (poster) ph.style.backgroundImage = 'url("' + poster + '")';
    card.insertBefore(ph, v);
    stage.appendChild(v);

    activeVideo = v;
    activePh = ph;
    modalOpen = true;
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';

    syncPlayback();

    var title = document.getElementById('modalProductTitle');
    var price = document.getElementById('modalProductPrice');
    var image = document.getElementById('modalProductImage');
    var btn   = document.getElementById('modalProductBtn');
    if (title) title.textContent = card.dataset.productTitle || '';
    if (price) price.textContent = card.dataset.productPrice || '';
    if (image) image.src = card.dataset.productImage || '';
    if (btn)   btn.href = card.dataset.productUrl || '#';

    v.loop = true;
    v.muted = false;
    var p = v.play();
    if (p && p.catch) {
      p.catch(function () {
        v.muted = true;
        var r = v.play();
        if (r && r.catch) r.catch(function () {});
      });
    }
  }

  function closeModal() {
    if (!modalOpen) return;
    modal.classList.remove('active');
    modalOpen = false;
    document.body.style.overflow = '';

    if (activeVideo && activePh && activePh.parentNode) {
      activeVideo.muted = true;
      activePh.parentNode.replaceChild(activeVideo, activePh);
    }
    activeVideo = null;
    activePh = null;
    syncPlayback();
  }

  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      if (dragMoved || modalOpen) return;
      openModal(card);
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) closeModal();
  });

  /* ───────── arrows + drag ───────── */
  function step() {
    var c = cards[0];
    return (c ? c.getBoundingClientRect().width : 260) + 20;
  }
  if (prevBtn) prevBtn.addEventListener('click', function () { wrapper.scrollBy({ left: -step(), behavior: 'smooth' }); });
  if (nextBtn) nextBtn.addEventListener('click', function () { wrapper.scrollBy({ left:  step(), behavior: 'smooth' }); });

  var isDown = false, startX = 0, scrollLeft = 0, dragMoved = false;
  wrapper.addEventListener('mousedown', function (e) {
    isDown = true; dragMoved = false;
    startX = e.pageX - wrapper.offsetLeft;
    scrollLeft = wrapper.scrollLeft;
  });
  wrapper.addEventListener('mouseleave', function () { isDown = false; });
  wrapper.addEventListener('mouseup', function () {
    isDown = false;
    setTimeout(function () { dragMoved = false; }, 0);
  });
  wrapper.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    e.preventDefault();
    var x = e.pageX - wrapper.offsetLeft;
    var walk = (x - startX) * 1.2;
    if (Math.abs(walk) > 6) dragMoved = true;
    wrapper.scrollLeft = scrollLeft - walk;
  });

  /* ───────── auto scroll ───────── */
  var AUTOPLAY_SPEED = 2500;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var reelTimer = null;

  function stopReelAuto() {
    if (reelTimer) { clearInterval(reelTimer); reelTimer = null; }
  }

  function startReelAuto() {
    stopReelAuto();
    if (reduceMotion) return;
    reelTimer = setInterval(function () {
      if (modalOpen || document.hidden || !inViewport) return;
      var atEnd = wrapper.scrollLeft + wrapper.clientWidth >= wrapper.scrollWidth - 4;
      wrapper.scrollTo({ left: atEnd ? 0 : wrapper.scrollLeft + step(), behavior: 'smooth' });
    }, AUTOPLAY_SPEED);
  }

  wrapper.addEventListener('mouseenter', stopReelAuto);
  wrapper.addEventListener('mouseleave', startReelAuto);
  wrapper.addEventListener('touchstart', stopReelAuto, { passive: true });
  wrapper.addEventListener('touchend', startReelAuto, { passive: true });
  document.addEventListener('visibilitychange', function () {
    document.hidden ? stopReelAuto() : startReelAuto();
  });

  startReelAuto();
})();

  } catch(e) { console.error(e); }
})();
})();
